import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"
import { isLoadingCommonFilters } from "@signals"
import { areCommonFiltersValid } from "@signals/commonFilters/filters"
import { Box } from "@mui/material"
import { filterSearchButtonProps } from "@components/@base/FilterPanel"


export default function LeadingAnalyzerFiltersFooterActions() {

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1.5 }}>
		<ButtonLoadingSeeker
			loading={isLoadingCommonFilters.value}
			{...filterSearchButtonProps}
			onClick={() => isLoadingCommonFilters.value = true}
			disabled={!areCommonFiltersValid.value}
		>
			Search
		</ButtonLoadingSeeker>
	</Box>
}